/**
 * The Notification Gateway module's paths.
 *
 * These mirror the notification service's gateway CRUD surface. The service is
 * not yet on the shared CRUD envelope, so the paths are declared by hand rather
 * than generated from a resource module.
 */

const BASE = '/v1/notifications/gateways' as const;

export const gatewayEndpoints = {
  list: BASE,
  create: BASE,
  detail: (id: string): string => `${BASE}/${encodeURIComponent(id)}`,
  update: (id: string): string => `${BASE}/${encodeURIComponent(id)}`,
  delete: (id: string): string => `${BASE}/${encodeURIComponent(id)}`,
} as const;
